const addressOneDataModel = {
  'addresses.1.house_number': 'number',
  'addresses.1.address_line_1': 'line1',
  'addresses.1.address_line_2': 'line2',
  'addresses.1.address_line_3': 'line3',
  'addresses.1.address_line_4': 'line4',
  'addresses.1.postcode': 'postcode',
};

const addressTwoDataModel = {
  'addresses.2.house_number': 'number',
  'addresses.2.address_line_1': 'line1',
  'addresses.2.address_line_2': 'line2',
  'addresses.2.address_line_3': 'line3',
  'addresses.2.address_line_4': 'line4',
  'addresses.2.postcode': 'postcode',
};

const mapAddressToFields = (number, address) => ({
  [`addresses.${number}.house_number`]: address.house_number,
  [`addresses.${number}.address_line_1`]: address.address_line_1,
  [`addresses.${number}.address_line_2`]: address.address_line_2,
  [`addresses.${number}.address_line_3`]: address.address_line_3,
  [`addresses.${number}.address_line_4`]: address.address_line_4,
  [`addresses.${number}.postcode`]: address.postcode,
});

const resetAddressFields = number => ({
  [`addresses.${number}.house_number`]: '',
  [`addresses.${number}.address_line_1`]: '',
  [`addresses.${number}.address_line_2`]: '',
  [`addresses.${number}.address_line_3`]: '',
  [`addresses.${number}.address_line_4`]: '',
  [`addresses.${number}.postcode`]: '',
});

export {
  addressOneDataModel,
  addressTwoDataModel,
  mapAddressToFields,
  resetAddressFields,
};
